<template>
  <div v-loading="loading">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="文字评语"
        name="text">
        <div class="edit TeacherSloganConfig">
          <el-row>
            <el-col :span="20">
              <el-form
                ref="editList"
                :model="formData"
                label-width="50px"
                class="demo-dynamic">
                <el-form-item
                  v-for="(item, index) in formData.editList"
                  :label="`${index + 1}星`"
                  :key="index"
                  :error="listErrors[index]"
                >
                  <el-tag
                    v-for="tag in item"
                    :key="tag"
                    :disable-transitions="false"
                    closable
                    @close="handleClose(item, tag)">
                    {{ tag }}
                  </el-tag>
                  <el-input
                    v-if="inputVisibleList[index].inputVisible"
                    ref="saveTagInput"
                    v-model="inputValue"
                    :class="['input-new-tag', `saveTagInput${index}`]"
                    placeholder="请输入内容"
                    type="text"
                    maxlength="50"
                    show-word-limit
                    size="small"
                    style="width: 200px;"
                    @keyup.enter.native="handleInputConfirm(index)"
                    @blur="handleInputConfirm(index)"
                  />
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput(index)">+ 添加评语</el-button>
                  <el-button
                    v-if="(index+1) === formData.editList.length"
                    class="del button-new-tag"
                    @click.prevent="removeDomain(item)">删除</el-button>
                </el-form-item>
                <el-form-item class="btn">
                  <el-button @click="addDomain">新增星级</el-button>
                  <el-button
                    type="primary"
                    @click="submitForm()">提交</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="老师形象"
        name="image">
        <div class="edit TeacherSloganConfig image">
          <el-row>
            <el-col :span="20">
              <el-form
                ref="editList"
                :model="formData"
                label-width="50px"
                class="demo-dynamic">
                <el-form-item>
                  <AppMasker
                    v-for="(item, index) in formData.imageList"
                    :key="index"
                    types="delete"
                    class="image-list-item"
                    width="150px"
                    height="150px"
                    radius
                    @delete="removeImage(index)"
                  >
                    <img :src="item[0]">
                  </AppMasker>
                  <AppQiniu
                    type="image"
                    width="150px"
                    height="150px"
                    class="view-material__item"
                    token-url="/resource/upload_token"
                    token-mode="name"
                    @success="data => materialEdit(data)"
                  />
                </el-form-item>
                <el-form-item class="btn">
                  <el-button
                    type="primary"
                    @click="submitFormImage()">提交</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { $http } from "@/utils";

export default {
  name: "TeacherSloganConfig",
  data() {
    return {
      activeName: "text",
      loading: true,
      formData: {
        editList: [],
        imageList: [],
      },
      imageList: [],
      listErrors: [],
      inputVisibleList: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  created() {
    this.load();
  },
  methods: {
    handleClick(tab, event) {
      switch (tab.name) {
        case "text":
          this.load();
          break;
        case "image":
          this.loadImage();
          break;
      }
    },
    load() {
      this.loading = true;
      $http.get("/config/study_report_teacher_comment", {})
        .then((res) => {
          this.formData.editList = res.data;
          this.inputVisibleList = res.data.map(item => ({ inputVisible: false }));
          this.loading = false;
        })
        .catch((err) => {
          this.$notify.error({
            title: "错误",
            message: err.message,
          });
          this.loading = false;
        });
    },
    submitForm() {
      const check = this.formData.editList.map(item => item.length);
      if (check.indexOf(0) !== -1) {
        this.$alert("请添加星级评语!");
      } else {
        this.loading = true;
        const data = {
          value: this.formData.editList,
        };
        $http.put("/config/study_report_teacher_comment", data)
          .then((res) => {
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success",
            });
            this.load();
          })
          .catch((err) => {
            this.$notify.error({
              title: "错误",
              message: err.message,
            });
            this.loading = false;
          });
      }
    },
    removeDomain(item) {
      const index = this.formData.editList.indexOf(item);
      this.$confirm("是否删除该星级评语？").then(() => {
        if (index !== -1) {
          this.formData.editList.splice(index, 1);
          this.inputVisibleList.splice(index, 1);
        }
      });
    },
    addDomain() {
      this.formData.editList.push([]);
      this.inputVisibleList.push({ inputVisible: false });
    },
    handleClose(item, tag) {
      item.splice(item.indexOf(tag), 1);
    },
    showInput(index) {
      this.inputVisibleList[index].inputVisible = true;
      this.$nextTick((_) => {
        const dom = document.querySelector(`.saveTagInput${index} input`);
        dom.focus();
      });
    },
    handleInputConfirm(index) {
      if (this.inputValue) {
        this.formData.editList[index].push(this.inputValue);
      }
      this.inputVisibleList[index].inputVisible = false;
      this.inputValue = "";
    },

    loadImage() {
      this.loading = true;
      $http.get("/config/study_report_teacher_avatar", {})
        .then((res) => {
          this.formData.imageList = res.data;
          this.loading = false;
        })
        .catch((err) => {
          this.$notify.error({
            title: "错误",
            message: err.message,
          });
          this.loading = false;
        });
    },
    materialEdit(data) {
      this.formData.imageList.push([data.url]);
    },
    removeImage(index) {
      this.$confirm("是否删除该形象？").then(() => {
        this.formData.imageList.splice(index, 1);
      });
    },
    submitFormImage() {
      this.loading = true;
      const data = {
        value: this.formData.imageList,
      };
      $http.put("/config/study_report_teacher_avatar", data)
        .then((res) => {
          this.$notify({
            title: "成功",
            message: "提交成功",
            type: "success",
          });
          this.loadImage();
        })
        .catch((err) => {
          this.$notify.error({
            title: "错误",
            message: err.message,
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.edit .el-input{
    width: 100px;
    margin: 0 10px;
}
.edit .del{
    margin: 0 10px;
}
</style>
<style>
.TeacherSloganConfig .edit .btn .el-form-item__content{
    margin-left: 0 !important;
}
.TeacherSloganConfig .el-tag{
    margin-bottom: 10px;
}
.TeacherSloganConfig .el-tag + .el-tag {
    margin-left: 10px;
}
.TeacherSloganConfig .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.TeacherSloganConfig .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.TeacherSloganConfig .el-input__inner {
    vertical-align: top !important;
}
.TeacherSloganConfig .el-form-item__content{
    flex-wrap: wrap;
}
.TeacherSloganConfig .image-list-item{
  margin: 15px 10px;
  line-height: 150px;
  text-align: center;
}
.TeacherSloganConfig .image-list-item img{
    max-width: 100%;
    max-height: 100%;
    display: inline-block;
    vertical-align: middle;
}
.TeacherSloganConfig .el-form-item__content{
  margin-left: 0 !important;
}
</style>
